<template>
  <span>
    <span class="mr-1">{{ label }}</span>
    <b-badge
      v-if="status"
      pill
      :variant="badge"
      class="badge-outlined">{{ $t(status) }}</b-badge>
  </span>
</template>

<script>
export default {
  props: {
    kitVersion: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      statuses: {
        VALIDATED: { badge: 'success' },
        NOT_VALIDATED: { badge: 'info' },
        PERF: { badge: 'danger' },
        default: { badge: 'secondary' }
      }
    };
  },
  computed: {
    label() {
      return this.kitVersion?.version;
    },
    status() {
      return this.kitVersion?.status;
    },
    badge() {
      const status = this.statuses[this.status];

      if (!status) {
        return this.statuses.default.badge;
      }

      return status.badge;
    }
  }
};
</script>